import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { AppConfig } from '../../../app/app.config';

/**
 * Generated class for the DailyLogSummaryPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-daily-log-summary',
  templateUrl: 'daily-log-summary.html',
})
export class DailyLogSummaryPage {
  config = AppConfig.settings;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
  ) {
  }

  static ionViewDidLoad() {
  }

}



// WEBPACK FOOTER //
// ./src/pages/daily-log/daily-log-summary/daily-log-summary.ts